export function transformProfileToTopicGuideId(profile) {
    const maybeTopicGuideId = profile?.data?.items?.find((item) => item?.children?.[0]?.guideId?.[0] === 't')?.children?.[0]?.guideId;
    return maybeTopicGuideId?.[0] === 't' ? maybeTopicGuideId : undefined;
}
